import React from 'react';
import {PropTypes} from 'prop-types';
import HrbTranslate from '../language/HrbTranslate';
import './CardWidget.scss';
import NewPasswordInput from "../password/new-password/NewPasswordInput";

const CardWidgetNewPasswordInput = (props) => (
    <div>
      <div className="hrb-card-widget-input-label">
        <HrbTranslate text={props.fieldLabel}/>
      </div>
      <NewPasswordInput onPasswordChanged={props.onChange} onBlur={props.onBlur}/>
    </div>
);

CardWidgetNewPasswordInput.propTypes = {
  fieldLabel: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func
};

export default CardWidgetNewPasswordInput